import React, {createContext, useEffect, useState} from "react";
import {useLocation} from 'react-router-dom'

export const NavBarContext = createContext()


export const NavBarProvider = ({children}) => {
    const [selectedPage, setSelectedPage] = useState('/admin')
    const location = useLocation()

    useEffect(() => {
        const path = location.pathname.split('/');
        const current = path[1] + (path[2]?('/' + path[2]):'')
        if (current) {
            setSelectedPage('/' + current)
        }
    }, [location.pathname])


    return (
        <NavBarContext.Provider value={{selectedPage, setSelectedPage}}>
            {children}
        </NavBarContext.Provider>
    )
}